// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Instagram: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M16.5 2h-9A5.51 5.51 0 0 0 2 7.499V16.5A5.51 5.51 0 0 0 7.499 22H16.5a5.51 5.51 0 0 0 5.5-5.499V7.5A5.51 5.51 0 0 0 16.501 2H16.5ZM20 16.5a3.5 3.5 0 0 1-3.5 3.5h-9A3.5 3.5 0 0 1 4 16.5v-9A3.5 3.5 0 0 1 7.5 4h9A3.5 3.5 0 0 1 20 7.5v9Z" />
    <path d="M16.59 11.29a4.589 4.589 0 0 0-3.855-3.877l-.025-.003a4.37 4.37 0 0 0-1.375.004l.025-.003c-2.233.34-3.925 2.248-3.925 4.55a4.6 4.6 0 0 0 4.563 4.6H12a5.084 5.084 0 0 0 .696-.001h-.016a4.607 4.607 0 0 0 3.877-5.245l.003.025.03-.05Zm-4.17 3.24a2.59 2.59 0 0 1-2.949-2.176l-.002-.014a2.596 2.596 0 0 1 .534-1.936L10 10.41a2.565 2.565 0 0 1 1.697-1h.013a2.223 2.223 0 0 1 .39 0l-.01-.001a2.244 2.244 0 0 1 .39 0h-.01a2.603 2.603 0 0 1 2.206 2.57 2.6 2.6 0 0 1-2.19 2.568l-.016.002-.049-.02ZM17 6.05a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" />
  </SvgIcon>
);

Instagram.activeColor = 'inherit';
Instagram.muiName = 'Instagram';
